export enum EstatePrimaryContactTypeEnum {
  Individual = 'individual',
  Organization = 'organization'
}
